import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { List, Body } from "./components";
import { connect } from "react-redux";
import * as actions_body from "redux/actions/knowledgeActions";
import * as actions_list from "redux/actions/knowledgeCategoryActions";
import { Translate, I18n } from "react-redux-i18n";

const Knowledge = (props) => {

    const { className, history, ...rest } = props;
    const [categoryId, setCategoryId] = useState(1);

    const onCategorySelect = useCallback((id) => {
        if (id != null) setCategoryId(id);
    }, []);

    useEffect(() => {
        props.loadList({
            id: props.user_id,
        }, props.token);
        props.loadBody({
            id: props.user_id,
            category_id: 1
        }, props.token);

    }, []);

    return (
                <div className="knowledge-panel">
                    <div className="card-header">
                        <div className="card-header-title">
                            <Translate value="knowledge" />
                        </div>
                    </div>
                    <div className="card-content">
                        <div className="knowledge-layout">
                            <List onCategorySelect={onCategorySelect} />
                            <div className="knowledge-main">
                                <Body categoryId={categoryId} />
                            </div>
                        </div>
                    </div>
                </div>
    );
};

Knowledge.propTypes = {
    className: PropTypes.string,
    history: PropTypes.object
};

function mapStateToProps(reducer) {
    //console.log(reducer);    
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,

        list: reducer.knowledge.list,
        loading: reducer.knowledge.loading,
        error: reducer.knowledge.error,

    };
}
const mapDispatchToProps = dispatch => ({

    loadList: (params, token) =>
        dispatch(actions_list.loadList({ params, token })),
    loadBody: (params, token) =>
        dispatch(actions_body.loadList({ params, token })),

});

export default connect(mapStateToProps, mapDispatchToProps)(Knowledge);